// Массовая загрузка правил цены: одна строка — одно правило.
// Формат: «бренд или SKU; значение; [до YYYY-MM-DD]; [поставщик]; [причина]»,
// разделитель «;» или табуляция (вставка из Excel). Тип области, режим и
// «разрешить ниже безубыточности» берутся из формы.

const DATE_RE = /^(?:до\s*)?(\d{4}-\d{2}-\d{2})$/i;

export const parseRuleLines = (text, defaults) => {
    const items = [];
    const errors = [];
    String(text || "")
        .split(/\r?\n/)
        .forEach((rawLine, index) => {
            const line = rawLine.trim();
            if (!line) return;
            const parts = line.split(/\t|;/).map((part) => part.trim());
            const [scopeValue, rawValue, ...rest] = parts;
            const lineNo = index + 1;
            if (!scopeValue) {
                errors.push(`Строка ${lineNo}: нет бренда/SKU`);
                return;
            }
            const value = Number(String(rawValue || "").replace(",", "."));
            if (!rawValue || !Number.isFinite(value) || value < 0) {
                errors.push(`Строка ${lineNo}: значение «${rawValue || ""}» не число`);
                return;
            }
            let validUntil = null;
            let supplierCode = null;
            let reason = null;
            rest.forEach((part) => {
                if (!part) return;
                const dateMatch = part.match(DATE_RE);
                if (dateMatch && !validUntil) {
                    validUntil = new Date(`${dateMatch[1]}T23:59:59`).toISOString();
                } else if (!supplierCode && /^D\d+$/i.test(part)) {
                    supplierCode = part.toUpperCase();
                } else if (!reason) {
                    reason = part;
                }
            });
            items.push({
                scope_type: defaults.scope_type,
                scope_value: scopeValue,
                mode: defaults.mode,
                value,
                valid_until: validUntil,
                supplier_code: supplierCode,
                allow_below_breakeven: Boolean(defaults.allow_below_breakeven),
                reason,
            });
        });
    return { items, errors };
};

export default parseRuleLines;
